'use client';
import React, { useRef, useState, useEffect } from 'react';
import AppLayout from '@/components/AppLayout';
import FoodLogHeader from './components/FoodLogHeader';
import MacroSummaryBar from './components/MacroSummaryBar';
import MealSections, { MealSectionsHandle } from './components/MealSections';
import FoodSearchPanel from './components/FoodSearchPanel';
import AIQuickSearch from './components/AIQuickSearch';

export default function FoodLoggingPage() {
  const mealSectionsRef = useRef<MealSectionsHandle>(null);
  const [meals, setMeals] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (mealSectionsRef.current) {
        setMeals(mealSectionsRef.current.getMeals());
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  function handleAddFood(
    food: { name: string; grams: number; cal: number; protein: number; carbs: number; fat: number },
    mealId: string
  ) {
    mealSectionsRef.current?.addFoodToMeal(food, mealId);
  }

  return (
    <AppLayout activeRoute="/food-logging">
      <div className="space-y-4 sm:space-y-6">
        <FoodLogHeader />
        <MacroSummaryBar />
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 sm:gap-6">
          <div className="xl:col-span-2">
            <MealSections ref={mealSectionsRef} />
          </div>
          <div className="space-y-4">
            <AIQuickSearch onAddFood={handleAddFood} meals={meals} />
            <FoodSearchPanel onAddFood={handleAddFood} meals={meals} />
          </div>
        </div>
      </div>
    </AppLayout>
  );
}